import { FC } from "react";
import classes from './transactionItem.module.scss'
import { ITransactionsAdmin } from "../../model/types";
import { Link } from "react-router-dom";
import { formatUtcToMsk } from "../../../../shared/lib/helpers/formatUtcToMsk";
import { LabelText } from "../../../../shared/ui/sign";
import { TransactionMetaPopover } from "../../../../shared/ui/transactionMeta/TransactionMetaPopover";

interface IProps {
    transaction: ITransactionsAdmin;
}

export const AdminTransactionItemMobile: FC<IProps> = ({transaction}) => {
    return (
        <section
            className={classes.itemMobile}
        >
            <LabelText
                label="Дата"
                text={formatUtcToMsk(transaction.created_at) + " (мск)"}
            />
            <LabelText
                label="Сумма"
                text={transaction.amount}
            />
            <LabelText
                label="Подтвержденная"
                text={transaction.is_confirmed ? <>&#9989;</> : <>&#10060;</>}
            />
            <LabelText
                label="Ручная"
                text={transaction.is_manual ? <>&#9989;</> : <>&#10060;</>}
            />
            <LabelText
                label="ФИО студента"
                text={<Link to={'/students/' + transaction.student_id}>{transaction.student_name}</Link>}
            />
            <LabelText
                label="Доп. информация"
                text={<TransactionMetaPopover meta={transaction.meta} />}
            />
        </section>
    )
}
